import { useEffect, useEffectEvent, useState } from "react";

interface Props {
  onDrag?: (e: PointerEvent) => void;
  onEnd?: (e: PointerEvent) => void;
  onStart?: (e: PointerEvent) => void;
}

export const useDrag = <T extends HTMLElement>({
  onDrag,
  onEnd,
  onStart,
}: Props) => {
  const [isDragging, setIsDragging] = useState(false);

  const onPointerDown = (e: React.PointerEvent<T>) => {
    setIsDragging(true);
    onStart?.(e.nativeEvent);
  };

  const onPointerMove = useEffectEvent((e: PointerEvent) => {
    onDrag?.(e);
  });

  const onPointerUp = useEffectEvent((e: PointerEvent) => {
    setIsDragging(false);
    onEnd?.(e);
  });

  useEffect(() => {
    if (isDragging) {
      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp);
      return () => {
        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);
      };
    }
  }, [isDragging]);

  return {
    onPointerDown,
  };
};
